/**
 * Custom error classes for assistant management domain
 * 
 * These errors represent domain-specific error conditions that can occur
 * during assistant operations (create, update, etc.)
 */

/**
 * Error thrown when attempting to create or update an assistant with a name
 * that already exists in the same account
 */
export class NameDuplicateError extends Error {
    constructor(message: string) {
      super(message);
      this.name = 'NameDuplicateError';
      // Maintains proper stack trace for where our error was thrown (only available on V8)
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, NameDuplicateError);
      }
    }
  }
  